import Router from '@/router'
import {
  TOKEN_KEY,
  PROFILE_KEY,
  BRANCH_ID,
  CURRENT_YEAR
} from '@/libs/acl/config'
import { applyDesignFlag } from '@/libs/design'
import store from '@/store'

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem(TOKEN_KEY) || null,
    profile: JSON.parse(localStorage.getItem(PROFILE_KEY)) || {
      isAdmin: false,
    },
    branchId: localStorage.getItem(BRANCH_ID) || null
  },
  getters: {
    token: state => state.token || null,
    profile: state => state.profile || {},
    branchId: state => state.branchId || null,
    isHesbaClient: state => !!state.profile?.isHesbaClient,
  },
  mutations: {
    setToken(state, token) {
      localStorage.setItem(TOKEN_KEY, token)
      state.token = token
    },
    setProfile(state, profile) {
      localStorage.setItem(PROFILE_KEY, JSON.stringify(profile))
      state.profile = profile
      applyDesignFlag(!!profile?.isHesbaClient, store)
    },
  },
  actions: {
    login({ commit, dispatch }, { userName, password }) {
      dispatch(
        'app/create',
        { url: 'Users/auth', data: { userName: userName, password: password } },
        { root: true },
      ).then(data => {
        commit('setToken', data.token)
        commit('setProfile', data);
        if (data.defaultBranchId) {
          localStorage.setItem(BRANCH_ID, data.defaultBranchId);
          this.state.app.branchId = data.defaultBranchId;
        }
        dispatch('app/fetchAccountsEnabled', null, { root: true });
        if (data.isNewTenant && !data.isInvoicePlan) {
          Router.push({
            name: 'startUp-branch-edit',
            params: { id: data.defaultBranchId },
          });
        } else {
          Router.push('/')
        }
      })
    },
    logout({ commit }) {
      this.state.app.branchId = null;
      window.localStorage.removeItem(TOKEN_KEY)
      window.localStorage.removeItem(PROFILE_KEY)
      window.localStorage.removeItem(CURRENT_YEAR)
      commit('app/CLEAR_ACCOUNTS_ENABLED', null, { root: true })
      commit('setToken', '')
      commit('setProfile', {})
      Router.push('/login')
    },
    changePassword() {
      Router.push('/change-password')
    },
  },
}
